// src/MessageItem.tsx
import React from "react";
import { Message } from "../api/models";
import { QuestionMessage } from "./QuestionMessage";
import { AnswerMessage } from "./AnswerMessage";

interface Props {
  message: Message;
  onFollowUpClick: (question: string) => void;
  isLatestAssistant?: boolean;
  precedingQuestion?: string; // User's question for export context
  onRateLimitError?: (error: any) => void;
}

export const MessageItem: React.FC<Props> = ({ message, onFollowUpClick, isLatestAssistant = false, precedingQuestion = '', onRateLimitError }) => {
  if (message.role === "user") {
    return <QuestionMessage question={message.englishText || ""} domId={message.uiMessageId} />;
  } else {
    return (
      <AnswerMessage
        eventMessages={message.eventMessages || []}
        englishText={message.englishText || ""}
        citations={message.citations || []}
        citationTitles={message.citationTitles || {}}
        followUpQuestions={message.followUpQuestions || []}
        responseLanguage={message.responseLanguage}
        domId={message.uiMessageId}
        conversationId={message.id || ""}
        messageId={message.messageId || ""}
        onFollowUpClick={onFollowUpClick}
        error={message.error}
        isThinking={message.isThinking}
        isStreaming={message.isStreaming}
        prefetchedAudio={message.prefetchedAudio}
        prefetchedVoice={message.prefetchedVoice}
        prefetchedSpeed={message.prefetchedSpeed}
        voiceSynthesisStatus={message.voiceSynthesisStatus}
        isLatestAssistant={isLatestAssistant}
        precedingQuestion={precedingQuestion}
        onRateLimitError={onRateLimitError}
      />
    );
  }
};
